var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.879C19 20.1763 18.8888 20.4614 18.6908 20.6717C18.4929 20.8819 18.2244 21 17.9444 21H1.05556C0.775605 21 0.50712 20.8819 0.309165 20.6717C0.11121 20.4614 2.54083e-07 20.1763 2.54083e-07 19.879V8.09689C-0.000111344 7.92606 0.0365403 7.75746 0.107156 7.60397C0.177771 7.45048 0.280482 7.31616 0.407445 7.21127L8.85189 0.236195C9.03718 0.0831126 9.26524 0 9.5 0C9.73476 0 9.96282 0.0831126 10.1481 0.236195L18.5926 7.21127C18.7195 7.31616 18.8222 7.45048 18.8928 7.60397C18.9635 7.75746 19.0001 7.92606 19 8.09689V19.879ZM16.8889 18.7579V8.64395L9.5 2.54104L2.11111 8.64395V18.7579H16.8889Z",
    fill: "#091F82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a91ce5765a3913737ac75211dca7c22b.svg";
export { ForwardRef as ReactComponent };